class AptModalController {
  static bindings = {
    visible: '<',
    size: '<',
    onSave: '&',
    onCancel: '&',
    isSaveDisabled: '<'
  };

  visible;
  size;

  /**
   * This should return a promise to delay closing the modal, otherwise it will close immediately
   *
   * @param {any} $event [description]
   */
  onSave;

  /**
   * This should return a promise to delay closing the modal, otherwise it will close immediately
   *
   * @param {any} $event [description]
   */
  onCancel;

  isSaveDisabled;

  private deferred;

  validSizes = {
    lg: 'modal-lg',
    sm: 'modal-sm'
  };

  constructor(private $q) {
    'ngInject';

    this.deferred = $q.defer();

    this.deferred.promise.then(
      (resolved) => {
        // console.log('Modal promise resolved, closing modal');

        // TODO: Destroy the component
        this.visible = false;
      },
      (canceled) => {
        // console.log('Modal promise rejected, closing modal');

        // TODO: Destroy the component
        this.visible = false;
      }
    );
  }

  saveAction() {
    let promise = this.onSave();

    if (promise && typeof promise.then == 'function') {
      this.deferred.resolve();
    } else if (promise === undefined) {
      this.deferred.resolve();
    }
  }

  cancelAction() {
    let promise = this.onCancel();

    if (promise && typeof promise.then == 'function') {
      this.deferred.reject();
    } else if (promise === undefined) {
      this.deferred.reject();
    }
  }
}

export const AptModalComponent = {
  transclude: {
    titleSlot: 'modalTitle',
    bodySlot: 'modalBody',
    saveButtonSlot: '?saveButtonLabel',
    cancelButtonSlot: '?cancelButtonLabel'
  },
  template: `<div class="modal-backdrop am-fade" style="position: fixed; top: 0px; left: 0px; bottom: 0px; right: 0px; z-index: 1040;" ng-style="{ 'display': $ctrl.visible ? 'block' : 'none' }"></div>
    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true" ng-style="{ 'display': $ctrl.visible ? 'block' : 'none' }">
      <div class="modal-dialog" ng-class="$ctrl.size && $ctrl.validSizes[$ctrl.size] ? $ctrl.validSizes[$ctrl.size] : ''">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" aria-label="Close" ng-click="$ctrl.cancelAction()"><i class="fa fa-times"></i></button>
            <h3 class="modal-title"><ng-transclude ng-transclude-slot="titleSlot"></ng-transclude></h3>
          </div>
          <div class="modal-body" style="min-height: 400px;">
            <ng-transclude ng-transclude-slot="bodySlot"></ng-transclude>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link" ng-click="$ctrl.cancelAction($event)"><ng-transclude ng-transclude-slot="cancelButtonSlot">Cancel</ng-transclude></button>
            <button type="button" class="btn btn-primary" ng-click="$ctrl.saveAction($event)" ng-disabled="$ctrl.isSaveDisabled"><ng-transclude ng-transclude-slot="saveButtonSlot">Save</ng-transclude></button>
          </div>
        </div>
      </div>
    </div>`,
  controller: AptModalController,
  bindings: AptModalController.bindings
};
